// Dependencies
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

// Models
import { OrganizationModel } from '../models/organization.model';

// Services
import { AjaxService } from './ajax.service';

@Injectable()
export class OrganizationRequestService {
    constructor(private ajaxService: AjaxService, private http: Http) {}

    uploadLogo(organizationId: number, fileInput: any) {
        let formData:FormData = new FormData();
        formData.append('org_id', String(organizationId));
        formData.append('file', fileInput, fileInput.name);

        let headers = new Headers();
        headers.append('Accept', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(`${this.ajaxService.apiUrl}/orglogo`, formData, options)
            .map(res => res.json())
            .map(response => new OrganizationModel(response.data))
            .catch(error => Observable.throw(error));
            
            // .subscribe(response => new OrganizationModel(response.data));
    }
}


// WEBPACK FOOTER //
// ./src/app/services/organization-request.service.ts